<script>
import axiosInstance from '@/axios/axios';
import { inject, ref, onMounted } from 'vue';
import MandalaDisplay from './phrase/MandalaDisplay.vue';
import Step1_Intention from './phrase/Step1_Intention.vue';
import Step2_ShapeSelection from './phrase/Step2_ShapeSelection.vue';
import Step3_Customization from './phrase/Step3_Customization.vue';
import Modals from './phrase/Modals.vue';

import { encodeQueryData } from '@/utils.js';
import { DRAW_API_BASE } from '@/axios/axios';

export default {
  name: "Wish-Phrase",
  components: {
    MandalaDisplay,
    Step1_Intention,
    Step2_ShapeSelection,
    Step3_Customization,
    Modals
  },
  setup() {
    const payloadRegex = inject('payloadRegex');
    const payloadRegexG = inject('payloadRegexG');
    const userInfo = ref(null);

    onMounted(async () => {
      try {
        const response = await axiosInstance.get(`/api/auth/userinfo/`);
        userInfo.value = response.data;
      } catch (error) {
        console.error('Failed to fetch user info:', error);
      }
    });

    return {
      payloadRegex,
      payloadRegexG,
      userInfo
    };
  },
  data() {
    return {
      commondata: { menu: { shapes: {} } },
      b64image: "",
      steps: {
        1: true,
        2: false,
        3: false,
      },
      payload: "",
      patternsList: [],
      shapeSelected: "",
      shapeSelectedId: "",
      patternSymbols: "",
      patternLenSelected: 1,
      paletteSelected: 9,
      firstMethodSelected: "",
      additionalMethodSelected: "",
      main_matrix: { 1: [1] },
      pattern: "1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20",
      printDefaultMandala: true,
      printOnlyDigits: false,
      printOnlyDots: false,
      printDotsByNumbers: false,
      mandalaForm: "colorized",
      sectorLength: 8,
      open: false,
      print_open: false,
      currentStep: 1,
      showErrorModal: false,
      errorMessage: "",
      isLoading: false,
      isPreview: true,
      showMandalaConfirmation: false,
      showHelpModal: false
    };
  },
  computed: {
    computedLocale() {
      return this.$i18n.locale.trim();
    },
    fakePayload() {
      return this.payload.replace(!this.payloadRegex, '');
    },
    firstMethod: function () {
      if (this.commondata["methods"]) {
        return this.commondata["methods"];
      } else {
        return "";
      }
    },
    additionalMethod: function () {
      if (this.commondata["methods"]) {
        var methods = this.commondata["methods"];
        if (methods[this.firstMethodSelected]) {
          return methods[this.firstMethodSelected].additional_methods;
        }
      }
      return {};
    },
    firstMethodLength: function () {
      if (this.commondata["methods"]) {
        return Object.keys(this.commondata["methods"]).length;
      }
      return 0;
    },
    additionalMethodLength: function () {
      if (this.commondata["methods"]) {
        var methods = this.commondata["methods"];
        if (Object.keys(methods).length) {
          if (methods[this.firstMethodSelected].additional_methods) {
            return Object.keys(
              methods[this.firstMethodSelected].additional_methods
            ).length;
          } else {
            return 0;
          }
        } else {
          return 0;
        }
      } else {
        return 0;
      }
    },
    paletteRendered: function () {
      var result = {};
      if (this.patternSymbols) {
        var pattern_first_symbol =
          this.patternSymbols[0] < 2 ? 1 : this.patternSymbols[0];
        var temp_palette =
          this.commondata["palettes"][this.paletteSelected][
          pattern_first_symbol
          ];
        result[1] = {};
        result[2] = {};
        for (let i = 1; i <= 7; i++) {
          result[1][i] = {};
          result[1][i]["id"] = i;
          result[1][i]["hex"] = temp_palette[i];
        }
        for (let i = 8; i <= this.paletteSelected; i++) {
          result[2][i] = {};
          result[2][i]["id"] = i;
          result[2][i]["hex"] = temp_palette[i];
        }
        return result;
      }
      return result;
    },
    mainMatrixRendered: function () {
      let result = [];
      if (Object.keys(this.main_matrix).length > 1) {
        if (this.main_matrix[this.paletteSelected].length > 0) {
          for (
            let i = 0;
            i < this.main_matrix[this.paletteSelected].length;
            i++
          ) {
            let row = [];
            if (Array.isArray(this.main_matrix[this.paletteSelected][i])) {
              for (
                let j = 0;
                j < this.main_matrix[this.paletteSelected].length;
                j++
              ) {
                if (j < this.main_matrix[this.paletteSelected][i].length) {
                  row[j] = this.main_matrix[this.paletteSelected][i][j];
                } else {
                  row[j] = "";
                }
              }
              result[i] = row;
            }
          }
          return result;
        } else {
          return result;
        }
      } else {
        return result;
      }
    },
    payloadFactLength: function () {
      let symbolRegExp = "";
      symbolRegExp = this.payloadRegexG ? this.payloadRegexG : /[0-9a-zA-Zа-яА-ЯЁё_]/g;
      const matches = Array.from(this.payload.matchAll(symbolRegExp));
      const count = matches.length;
      console.log(`The number of matches for '${symbolRegExp}' is: ${count}`);
      return count || 0;
    },
    showSectorLength: function () {
      return ["eight_diamond", "six_diamond", "stern"].includes(this.shapeSelected) && this.firstMethodSelected[0] == '8'
    },
    remainingMandalaDrawings: function () {
      if (this.userInfo && this.userInfo.mandala_drawings) {
        return this.userInfo.mandala_drawings.remaining;
      }
      return null;
    },
    totalMandalaDrawings: function () {
      if (this.userInfo && this.userInfo.mandala_drawings) {
        return this.userInfo.mandala_drawings.allowed;
      }
      return null;
    }
  },
  beforeCreate() {
    axiosInstance
      .get(`/draw/api/v1/free/commondata/`)
      .then((response) => (this.commondata = response.data));
  },

  mounted() {
    const phraseFromQuery = this.$route.query.phrase;
    if (phraseFromQuery) {
      this.payload = phraseFromQuery;
      this.gotoStep(1); // Activate step 1
    }
  },

  methods: {
    gotoStep: function (step) {
      this.currentStep = step;
      for (let k in this.steps) {
        if (k <= step) {
          this.steps[k] = true;
        } else {
          this.steps[k] = false;
        }
      }
      // Scroll to show step 2 content when entering step 2
      if (step === 2) {
        this.$nextTick(() => {
          const step2Element = document.querySelector('.step-2-section') || document.getElementById('mandala-display');
          if (step2Element) {
            step2Element.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      }
    },
    buildQuerydata: function () {
      console.log(this.printOnlyDigits)
      const raw = this.$data;
      const allowed = [
        "payload",
        "shapeSelected",
        "shapeSelectedId",
        "pattern",
        "paletteSelected",
        "firstMethodSelected",
        "additionalMethodSelected",
        "patternLenSelected",
        "printDefaultMandala",
        "printOnlyDigits",
        "printDotsByNumbers",
        "printOnlyDots",
        "sectorLength",
      ];
      const filtered = Object.keys(raw)
        .filter((key) => allowed.includes(key))
        .reduce((obj, key) => {
          obj[key] = raw[key];
          return obj;
        }, {});
      return filtered;
    },
    gotoPrint() {
      let route = this.$router.resolve({
        path: "/print",
        query: this.buildQuerydata(),
      });
      window.open(route.href);
      this.print_open = false;
    },
    selectShapeId(e) {
      this.shapeSelectedId = e.id;
    },
    figureSelected() {
      console.log("figureSelected called with shape:", this.shapeSelected);
      this.gotoStep(2);
      this.draw_url = `${DRAW_API_BASE}premium/shape/${this.shapeSelected}?`;

      if (typeof this.shapeSelected !== 'undefined' && this.shapeSelected !== "") {
        console.log("Making API request for shape data");
        axiosInstance
          .get(`/draw/api/v1/premium/shapesdata/`, {
            params: {
              shape: this.shapeSelected,
              q: this.payload,
            },
          })
          .then((response) => {
            console.log("API response received:", response.status);
            return response.data;
          })
          .then((data) => {
            console.log("Shape data:", data);
            if (data) {
              Object.keys(data).forEach(key => {
                this.commondata[key] = data[key];
              });

              if (data.default_method && data.methods && data.methods[data.default_method]) {
                this.firstMethodSelected = data.default_method;
              } else {
                console.warn("Default method not found or invalid. Please select a method manually.");
              }
              if (data.default_additional_method) {
                this.additionalMethodSelected = data.default_additional_method;
              }
              if (data.main_matrix) {
                this.main_matrix = data.main_matrix;
              }

              var min_val = Math.min(
                this.payload.length,
                this.commondata["pattern_max_len"] || 10,
                this.payloadFactLength || 10
              ) || 1;

              this.patternsList = Array.from(Array(min_val).keys());
              this.patternClick();
            } else {
              console.error("Empty data received from API");
            }
          })
          .catch(error => {
            console.error("Error fetching shape data:", error);
          });
      } else {
        console.warn("Shape not selected or undefined");
      }
    },
    patternClick() {
      this.patternSymbols =
        this.commondata["main_matrix"][this.paletteSelected][
        this.commondata["main_matrix"][this.paletteSelected].length -
        this.patternLenSelected
        ];
      this.gotoStep(2);
    },
    sendDrawRequest(data) {
      let url = `${DRAW_API_BASE}premium/shape/${this.shapeSelected}?` + encodeQueryData(data);
      this.isLoading = true;
      return axiosInstance.get(url)
        .then((response) => {
          this.isLoading = false;
          this.b64image = response.data.pic || "";
          this.pattern = response.data.pattern;

          if (response.data.remaining_drawings !== undefined) {
            if (!this.userInfo) this.userInfo = {};
            if (!this.userInfo.mandala_drawings) this.userInfo.mandala_drawings = {};
            this.userInfo.mandala_drawings.remaining = response.data.remaining_drawings;
          }

          if (this.userDataRefresh) {
            this.userDataRefresh();
          }

          // Scroll to mandala display on mobile after generation
          this.$nextTick(() => {
            const mandalaDisplay = document.querySelector('.mandala-display-wrapper') || document.getElementById('mandala-display');
            if (mandalaDisplay) {
              mandalaDisplay.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          });
        })
        .catch((error) => {
          this.isLoading = false;
          console.error("API Error:", error);

          let errorMessage = this.$t('message.errorTitle') + ': ';

          if (error.response && error.response.data && error.response.data.error) {
            errorMessage += error.response.data.error;
          } else if (error.message) {
            errorMessage += error.message;
          } else {
            errorMessage += this.$t('message.networkError');
          }

          this.errorMessage = errorMessage;
          this.showErrorModal = true;
        });
    },
    processrequest() {
      if (!this.firstMethodSelected) {
        alert("Please select a method.");
        return;
      }
      console.log("processing request");
      if (this.isPreview) {
        this.createMandala();
      } else {
        this.showMandalaConfirmation = true;
      }
    },
    confirmCreateMandala() {
      this.showMandalaConfirmation = false;
      this.createMandala();
    },
    createMandala() {
      switch (this.mandalaForm) {
        case "colorized":
          this.colorizeShape();
          break;
        case "digits":
          this.unColorizeShape();
          break;
        case "dots":
          this.filterShape();
          break;
      }
      this.gotoStep(3);
    },
    colorizeShape() {
      const data = {
        q: this.payload,
        patternLength: this.patternLenSelected,
        palette_id: this.paletteSelected,
        first_method: this.firstMethodSelected,
        additional_method: this.additionalMethodSelected,
        sector_length: this.sectorLength,
        colorize: 1,
        watermarked: false,
      };
      this.sendDrawRequest(data);
    },
    unColorizeShape() {
      const data = {
        q: this.payload,
        patternLength: this.patternLenSelected,
        palette_id: this.paletteSelected,
        first_method: this.firstMethodSelected,
        additional_method: this.additionalMethodSelected,
        sector_length: this.sectorLength,
        colorize: 0,
        filter: "*",
        watermarked: false,
      };
      this.sendDrawRequest(data);
    },
    filterShape() {
      const data = {
        q: this.payload,
        patternLength: this.patternLenSelected,
        palette_id: this.paletteSelected,
        first_method: this.firstMethodSelected,
        additional_method: this.additionalMethodSelected,
        sector_length: this.sectorLength,
        colorize: 0,
        num_to_dot: 1,
        filter: this.pattern,
        watermarked: false,
      };
      this.sendDrawRequest(data);
    },
    phraseChange() {
      this.b64image = "";
      this.gotoStep(1);
      this.shapeSelected = "";
      this.pattern = "1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20";
      this.firstMethodSelected = "";
      this.additionalMethodSelected = "";
      delete this.commondata["methods"];
    },
    figureChange() {
      this.b64image = "";
      this.gotoStep(1);
      this.pattern = "1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20";
      this.firstMethodSelected = "";
      this.additionalMethodSelected = "";
      delete this.commondata["methods"];
      this.patternLenSelected = 1;
      this.paletteSelected = 9;
      this.figureSelected();
    },
    firstMethodSelect() {
      this.additionalMethodSelected = "";
    },
    openHelpModal() {
      this.showHelpModal = true;
    },
    closeHelpModal() {
      this.showHelpModal = false;
    },
    openMatrixModal() {
      this.open = true;
    },
    closeMatrixModal() {
      this.open = false;
    },
    openPrintModal() {
      this.print_open = true;
    },
    closePrintModal() {
      this.print_open = false;
    },
    closeErrorModal() {
      this.showErrorModal = false;
    },
    closeConfirmationModal() {
      this.showMandalaConfirmation = false;
    }
  }
}
</script>

<template>
  <div class="container mx-auto px-4 relative">
    <div class="flex justify-between items-center mb-4">
      <button @click="$router.push({ name: 'app' })" class="inline-flex items-center px-4 py-2 border border-blue-300 rounded-md shadow-sm text-sm font-medium text-blue-700 bg-blue-100 hover:bg-blue-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
        {{ $t('message.backToPhrases') }}
      </button>

      <!-- Step Indicator -->
      <div class="step-indicator">
        <div
          :class="['step-bubble', currentStep >= 1 ? (currentStep > 1 ? 'step-completed' : 'step-active') : 'step-inactive']">
          1</div>
        <div :class="['step-line', currentStep > 1 ? 'line-active' : 'line-inactive']"></div>
        <div
          :class="['step-bubble', currentStep >= 2 ? (currentStep > 2 ? 'step-completed' : 'step-active') : 'step-inactive']">
          2</div>
        <div :class="['step-line', currentStep > 2 ? 'line-active' : 'line-inactive']"></div>
        <div :class="['step-bubble', currentStep >= 3 ? 'step-active' : 'step-inactive']">3</div>
      </div>
    </div>

    <!-- Step 1: Intention - always at top -->
    <Step1_Intention
      :payload="payload"
      @update:payload="payload = $event"
      @phrase-change="phraseChange"
      @open-help-modal="openHelpModal"
    />

    <div class="grid grid-cols-1 md:grid-cols-8 lg:grid-cols-11 gap-6">
      <MandalaDisplay
        :b64image="b64image"
        :currentStep="currentStep"
        @open-help-modal="openHelpModal"
      />

      <div class="md:col-span-3 lg:col-span-4">
        <Step2_ShapeSelection
          :payload="payload"
          :steps="steps"
          :shapeSelected="shapeSelected"
          @update:shapeSelected="shapeSelected = $event"
          :firstMethodSelected="firstMethodSelected"
          @update:firstMethodSelected="firstMethodSelected = $event"
          :additionalMethodSelected="additionalMethodSelected"
          @update:additionalMethodSelected="additionalMethodSelected = $event"
          :commondata="commondata"
          :computedLocale="computedLocale"
          :firstMethodLength="firstMethodLength"
          :additionalMethodLength="additionalMethodLength"
          :firstMethod="firstMethod"
          :additionalMethod="additionalMethod"
          @figure-change="figureChange"
          @first-method-select="firstMethodSelect"
        />

        <Step3_Customization
          :steps="steps"
          :patternsList="patternsList"
          :patternLenSelected="patternLenSelected"
          @update:patternLenSelected="patternLenSelected = $event"
          :patternSymbols="patternSymbols"
          :showSectorLength="showSectorLength"
          :sectorLength="sectorLength"
          @update:sectorLength="sectorLength = $event"
          :paletteSelected="paletteSelected"
          @update:paletteSelected="paletteSelected = $event"
          :paletteRendered="paletteRendered"
          :mandalaForm="mandalaForm"
          @update:mandalaForm="mandalaForm = $event"
          :b64image="b64image"
          :pattern="pattern"
          @update:pattern="pattern = $event"
          :isPreview="isPreview"
          @update:isPreview="isPreview = $event"
          @pattern-click="patternClick"
          @open-matrix-modal="openMatrixModal"
          @process-request="processrequest"
          @open-print-modal="openPrintModal"
          :firstMethodSelected="firstMethodSelected"
          :remainingMandalaDrawings="remainingMandalaDrawings"
        />
      </div>
    </div>

    <Modals
      :open="open"
      @close-matrix-modal="closeMatrixModal"
      :print_open="print_open"
      @close-print-modal="closePrintModal"
      @go-to-print="gotoPrint"
      :showHelpModal="showHelpModal"
      @close-help-modal="closeHelpModal"
      :showErrorModal="showErrorModal"
      @close-error-modal="closeErrorModal"
      :errorMessage="errorMessage"
      :showMandalaConfirmation="showMandalaConfirmation"
      @close-confirmation-modal="closeConfirmationModal"
      @confirm-create-mandala="confirmCreateMandala"
      :showPaymentConfirmationModal="showPaymentConfirmationModal"
      @confirm-payment="confirmPayment"
      @cancel-payment="cancelPayment"
      :fakePayload="fakePayload"
      :payloadRegex="payloadRegex"
      :mainMatrixRendered="mainMatrixRendered"
      :printDefaultMandala="printDefaultMandala"
      @update:printDefaultMandala="printDefaultMandala = $event"
      :printOnlyDigits="printOnlyDigits"
      @update:printOnlyDigits="printOnlyDigits = $event"
      :printOnlyDots="printOnlyDots"
      @update:printOnlyDots="printOnlyDots = $event"
      :printDotsByNumbers="printDotsByNumbers"
      @update:printDotsByNumbers="printDotsByNumbers = $event"
    />
  </div>
</template>

<style>
label.btn.btn-outline-primary {
  min-width: 45px;
}

.matrixCell {
  max-width: 30px;
}

.step-indicator {
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;
}

.step-bubble {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 8px;
  font-weight: bold;
  transition: all 0.3s ease;
}

.step-line {
  height: 2px;
  flex-grow: 1;
  margin: auto 4px;
  max-width: 60px;
}

.step-active {
  background-color: #3b82f6;
  color: white;
  transform: scale(1.1);
}

.step-completed {
  background-color: #10b981;
  color: white;
}

.step-inactive {
  background-color: #e5e7eb;
  color: #6b7280;
}

.line-active {
  background-color: #3b82f6;
}

.line-inactive {
  background-color: #e5e7eb;
}

.mandala-placeholder {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 2px dashed #d1d5db;
  border-radius: 0.5rem;
  padding: 2rem;
  text-align: center;
  height: 100%;
  min-height: 140px;
}

@media (min-width: 768px) {
  .mandala-placeholder {
    min-height: 400px;
  }
}

.mandala-placeholder-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
  color: #9ca3af;
}

.remaining-counter {
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: rgba(59, 130, 246, 0.9);
  color: white;
  padding: 0.375rem 0.75rem;
  border-radius: 9999px;
  font-size: 0.875rem;
  font-weight: 600;
  z-index: 10;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.section-heading {
  font-weight: 600;
  color: #4b5563;
  margin-bottom: 0.75rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0px;
}

.section-heading-number {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #3b82f6;
  color: white;
  font-size: 0.875rem;
  margin-right: 0.5rem;
}

.help-button {
  margin-left: auto;
  cursor: pointer;
  color: #3b82f6;
  transition: color 0.2s ease;
}

.help-button:hover {
  color: #2563eb;
}

.help-text {
  color: #6b7280;
  font-size: 0.875rem;
  margin-bottom: 0.75rem;
}

.instruction-step {
  margin-bottom: 1rem;
  padding: 1rem;
  border-radius: 0.5rem;
  background-color: #f3f4f6;
}

.instruction-step-active {
  background-color: #eff6ff;
  border-left: 4px solid #3b82f6;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: scale(0.95);
}
</style>